<template>
    <div class="fixed z-50 pin overflow-auto bg-modal" :class="active ? 'block' : 'hidden'">
        <div class="bg-grey-dark relative rounded shadow max-w-sm h-auto mx-auto mt-24">
            <div class="p-6">
                <div class="text-center mb-4">
                    <img src="/static/img/login_img.png" alt="Tooddoc Logo" class="h-48">
                </div>

                <div class="text-center text-white">{{ $t('Signing_out') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'logout-modal',

    props: ['active']
}
</script>


// WEBPACK FOOTER //
// src/components/Patient/LogoutModal.vue